import React from 'react'
import { Link } from "react-router-dom";

function ErrorMessage(props) {
    return (
        <div className=" mb-2">
            <div className="flex justify-between p-4 rounded-md bg-red-50 border border-red-300">
                <div className="flex gap-3 sm:items-center">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>
                    <p className="text-red-600 sm:text-sm">
                        {props.message}

                        {/* <Link to="/auth/signup">
                            <a href="" className="underline font-medium hover:text-red-700 ml-1">Sign up?</a>
                        </Link> */}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ErrorMessage